<!--
 * @Description: 
 * @Author: houcw
 * @Date: 2023-06-11 11:16:43
 * @LastEditTime: 2023-07-02 10:13:06
 * @LastEditors: houcw
 * @Reference: 
-->
<template>
  <div class="person-card" :class="{ activeCard: personInfo.id == current }">
    <div class="info-detail">
      <div class="name">
        <i class="el-icon-chat-line-square"></i>
        <input
          type="text"
          class="inputBox"
          v-model="personInfo.name"
          v-if="editName"
          ref="inputBox"
          @blur="blurFun"
          @click.stop="inputClick"
        />
        <span class="text" v-else>{{ personInfo.name }}</span>
      </div>

      <div class="iconColor flex_center">
        <i
          class="el-icon-edit"
          @click.stop="editChatName"
          style="margin-right: 8px"
          v-if="!editName"
        ></i>
        <i
          class="el-icon-check"
          @click.stop="checkName(personInfo)"
          v-if="editName"
          style="margin-right: 8px"
        ></i>

        <i
          class="el-icon-close"
          @click.stop="editName = false"
          v-if="editName"
        ></i>
        <i class="el-icon-delete" v-if="!editName" @click.stop="deletItem"></i>
      </div>
    </div>
  </div>
</template>

<script>
import HeadPortrait from "./HeadPortrait.vue";
import { putChatName } from "@/api/getData";

export default {
  props: {
    personInfo: {
      default: {},
    },
    pcCurrent: {
      default: "",
    },
    index: Number,
  },
  components: {
    HeadPortrait,
  },
  data() {
    return {
      current: "",
      editName: false,
    };
  },
  watch: {
    pcCurrent: {
      handler(newVal, old) {
        this.isActive();
      },
      immediate: true,
      deep: true,
    },
  },
  methods: {
    inputClick() {
      console.log("input 被点击了");
    },
    isActive() {
      this.current = this.pcCurrent;
    },
    deletItem() {
      console.log(this.index);
      this.$emit("deleteOnce", this.index);
    },
    stopFun() {
      return;
    },
    editChatName() {
      this.editName = true;
      // document.querySelector('input').focus();
      this.$nextTick(() => {
        this.$refs.inputBox.focus();
      });
    },
    // 编辑姓名
    checkName(info) {
      let data = {
        name: this.personInfo.name,
        id: info.id,
      };
      putChatName(data).then((res) => {
        if (res.code == 200) {
          // this.$emit("changeName");
          this.editName = false;
        }
      });
    },

    blurFun() {
      //
    },
  },
};
</script>

<style lang="scss" scoped>
.person-card {
  width: 280px;
  height: 42px;
  border-radius: 6px;
  background-color: rgb(50, 54, 68);
  position: relative;
  padding: 0px 12px;
  box-sizing: border-box;
  cursor: pointer;
  display: flex;
  align-items: center;
  margin: 12px 0;
  .info-detail {
    display: flex;
    justify-content: space-between;
    width: 100%;

    .iconColor {
      color: #fff;
    }
  }

  .name {
    color: #fff;
    margin-bottom: 5px;
    display: flex;
    align-items: center;

    .text {
      margin-left: 10px;
      width: 180px;
      height: 30px;
      line-height: 30px;
      // background: red;
      display: inline-block;
      text-overflow: ellipsis;
      overflow: hidden;
      white-space: nowrap;
      font-size: 16px;
      &:focus {
        outline: none;
      }
    }
  }

  &:hover {
    // background-color: rgba(72, 101, 255, 0.8);
    background-color: rgba(72, 101, 255, 0.8);
    transition: 0.3s;
    box-shadow: 0 5px 20px rgba(52, 53, 65, 0.8);
    .info {
      .info-detail {
        .detail {
          color: #fff;
        }
      }
    }
  }
}

.activeCard {
  background-color: rgba(72, 101, 255, 0.8);
  // background-color: rgba(52, 53, 65, 0.9);
  transition: 0.3s;
  .info {
    .info-detail {
      .detail {
        color: #fff;
      }
    }
  }
}

.inputBox {
  border: none;
  width: 180px;
  line-height: 30px;
  margin-left: 10px;
  font-size: 16px;
  height: 30px;
  color: #fff;
  // background-color: rgba(52, 53, 65, 0.9);
  background-color: rgba(72, 101, 255, 0.8);
  // background: red;
  transition: 0.3s;
  outline: none;
}
input:focus {
  border: none;
  outline: none;
}
</style>